/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ButtonCommonTheme, SortableList, FormControl, ModalFooter, SortableListWithTwoInputs } from 'modules/theme';
import { colors } from 'modules/common/styles';
import { ModalForm, ModalFormContainer } from '../styles/main';
var uuid = require('uuid');

const ModalFormStyle = styled.div`
  .modal-form{
    padding: 0;
  }

  .sortable-wrapper{
    padding: 0 15px;
	padding-top: 15px;
}

  .sort-header{
    display: flex;
    justify-content: space-between;
    background: transparent;
    border-bottom: 1px solid #F2F2F2;
    margin-top: 10px;
    padding-left: 35px;

    > span {
      font-style: normal;
      font-weight: 800 !important;
      font-size: 14px;
      text-transform: uppercase;
      padding: 5px 20px 5px 40px;
      font-weight: bold;
      color: #2B3C93;
    }

    @media (max-width: 576px) {
      > span {
        font-size: 13px;
        padding: 5px 10px
      }
    }
  }
`

const Child = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .column-label{
    width: 35%;
    font-weight: 600;
    font-size: 14px;
    color: #010101;
    text-transform: capitalize;
}
  }
`;

const contextTypes = {
  closeModal: PropTypes.func.isRequired,
  __: PropTypes.func
};

class ManageColumns extends Component {
  constructor(props) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
    this.onChangeFields = this.onChangeFields.bind(this);
    this.onFieldChange = this.onFieldChange.bind(this);

    props.config.sort(function (a, b) {
      return a.order - b.order;
    });

    this.state = {
      fields: props.fields
        .filter(field => field.name !== "customerInfo" && field.name !== "agentInfo"),
      persistentFields: JSON.parse(JSON.stringify(
        props.fields
          .filter(field => field.name !== "customerInfo" && field.name !== "agentInfo"),
      )),
      droppedCustomerInfo: props.fields.find((field) => field.name === "customerInfo"),
      droppedAgentInfo: props.fields.find((field) => field.name === "agentInfo"),
    };
  }

  componentDidUpdate() {


  }

  onSubmit(e) {
    e.preventDefault();
    const columnsConfig = [];
    this.state.fields.forEach((field, index) => {
      const element = document.getElementById(field._id);
      columnsConfig.push({
        order: index,
        checked: element.checked,
        name: field.name,
        ...field,
        label: field.label.trim() !== "" ? field.label : this.state.persistentFields[index].label,
      });
    });

    columnsConfig.push(
      {
        ...this.state.droppedCustomerInfo,
        order: columnsConfig.length,
        indexNo: columnsConfig.length,
        checked: true,
        name: "customerInfo",
        label: "Customer Info",
        lable: "Customer Info",
      },
      {
        ...this.state.droppedAgentInfo,
        order: columnsConfig.length,
        indexNo: columnsConfig.length,
        checked: true,
        name: "agentInfo",
        label: "Agent Info",
        lable: "Agent Info",
      },
    );

    console.log(columnsConfig, "columnsConfig");

    this.props.save(columnsConfig);
  }

  // onFieldChange(e, fieldId) {
  //   let val = e.target.value;
  //   var fields = this.state.fields;
  //   for (var field of fields) {
  //     if (field._id === fieldId) {
  //       field.label = val;
  //     }
  //   }
  //   this.setState({ fields })
  // }

  onFieldChange(e, fieldId) {
    const val = e.target.value;
    // const fields = this.state.fields.map(field =>
    //   field._id === fieldId ? { ...field, label: val } : field
    // );
    // this.setState({ fields });
    this.setState(prevState => ({
      fields: prevState.fields.map(field =>
        field._id === fieldId ? { ...field, label: val } : field
      )
    }));
  }


  // onFieldCheckedChange(fieldId, value) {
  //   var fields = this.state.fields;
  //   for (var field of fields) {
  //     if (field._id === fieldId) {
  //       field.checked = value;
  //     }
  //   }
  //   this.setState({ fields })
  // }

  onFieldCheckedChange(fieldId, value) {
    this.setState(prevState => ({
      fields: prevState.fields.map(field =>
        field._id === fieldId ? { ...field, checked: value } : field
      )
    }));
  }


  onChangeFields(fields) {
    fields = fields.map((e, index) => {
      return {
        ...e,
        order: index
      }
    })
    this.setState({ fields })
  }

  render() {
    const { config } = this.props;
    const { modalType } = this.props;

    console.log('fieldsewe', this.state.fields)

    // const configMap = {};
    let _this = this;

    // config.forEach(config => {
    //   configMap[config] = true;
    // });

    const configMap = {};
    config.forEach(cfg => {
      configMap[cfg.name] = true; // or cfg.key if needed
    });


    const child = field => {
      let name = field.label;
      console.log('fieldssssss', field)
      console.log('Checkbox value:', configMap[field.key]);

      return (
        <Child>
          <span className='column-label text-truncate'>{field.name}</span>
          {/* <FormControl
            style={{ width: "50%", textTransform: 'uppercase' }}
            // className="text-truncate"
            id={String(uuid.v4())}
            type="input"
            value={name}
            placeholder={name}
            onChange={e => _this.onFieldChange(e, field._id)}
          /> */}
          <FormControl
            style={{ width: "50%", textTransform: 'uppercase' }}
            id={field._id}
            type="input"
            value={field.label}
            placeholder={field.label}
            onChange={e => this.onFieldChange(e, field._id)}
          />

          <FormControl
            id={field._id}
            // defaultChecked={configMap[field.name]}
            checked={field.checked}
            componentClass="checkbox"
            onChange={(e) => {
              _this.onFieldCheckedChange(field._id, e.target.checked)
            }}
          />
        </Child>
      );
    };

    return (
      <ModalFormStyle>
        <ModalForm onSubmit={this.onSubmit}>
          <ModalFormContainer className='d-flex flex-column overflow-y-hidden modal-form'>
            <div className='sort-header'>
              <span>Column field</span>
              <span>Column name</span>
              <span>Visible</span>
            </div>

            <SortableListWithTwoInputs
              isDragDisabled={this.props.isDragDisabled || false}
              fields={this.state.fields}
              child={child}
              onChangeFields={this.onChangeFields}
              isModal={true}
            />

          </ModalFormContainer>
          <ModalFooter modalType={modalType}>
            <ButtonCommonTheme
              type='greyModalBtn'
              onClick={() => this.props.closeModal()}
            >
              Cancel
            </ButtonCommonTheme>
            <ButtonCommonTheme
              type='blueModalBtn'
              btnType="submit"
            >
              Update
            </ButtonCommonTheme>
          </ModalFooter>
        </ModalForm>
      </ModalFormStyle>
    );
  }
}

ManageColumns.propTypes = {
  fields: PropTypes.array.isRequired,
  config: PropTypes.array,
  save: PropTypes.func.isRequired
};

ManageColumns.contextTypes = contextTypes;

export default ManageColumns;



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/ManageColumns.js